import React from 'react';

export const Column = () => <></>;
Column.colType = 'Column';

export const Date = () => <></>;
Date.colType = 'Date';
